









































































































































































































































































































































































import {Component} from 'vue-property-decorator'
import {OrbitTransactionGroupSummaryCollection} from '@/model/collection/OrbitTransactionGroupSummaryCollection'
import {OrbitTransactionGroupedItem} from '@/model/resource/OrbitTransactionGroupedItem'
import {OrbitReport} from '@/model/resource/OrbitReport'
import {OrbitReportPdfHelper} from '@/helpers/OrbitReportPdfHelper'
import {DateHelper} from '@/helpers/DateHelper'
import {EnvHelper} from '@/helpers/EnvHelper'
import {$} from '@/facade'
import Vue from 'vue'
import {InputSelect} from '@simpli/vue-input'
import {NetworkNamespace} from '@/enums/NetworkNamespace'
import {
  OrbitNetworkHelper,
  OrbitNetworkOption,
} from '@/helpers/OrbitNetworkHelper'

interface TransactionGroup {
  key: string
  address: string | null
  eventname: string | null
  round: number | null
  networkIdentifier: string | null
  idOrbitRoundFk: number | null
  totalTxs: number
  transactions: OrbitTransactionGroupedItem[]
  createdAt: Date | string | number | null
  updatedAt: Date | string | number | null
}

@Component({
  components: {
    InputSelect,
  },
  computed: {
    DateHelper() {
      return DateHelper
    },
  },
})
export default class ListOrbitTransactionsView extends Vue {
  collection = new OrbitTransactionGroupSummaryCollection()

  filterAddress = ''
  filterRound = ''
  networkFilter: string | null = null
  filterTimeout: ReturnType<typeof setTimeout> | null = null

  expandedGroup: string | null = null
  transactionsByGroupKey: Record<string, OrbitTransactionGroupedItem[]> = {}
  loadingHashesKey: string | null = null

  get groupedItems(): TransactionGroup[] {
    return this.collection.items.map(item => {
      // The network is part of the group: the backend groups by it too, so the
      // same address can hold one row per network for the same round.
      const key = `${item.address ?? ''}|${item.idOrbitRoundFk ??
        ''}|${item.networkIdentifier ?? ''}`

      return {
        key,
        address: item.address,
        eventname: this.collection.eventname || null,
        round: item.round ?? null,
        networkIdentifier: item.networkIdentifier ?? null,
        idOrbitRoundFk: item.idOrbitRoundFk ?? null,
        totalTxs: Number(item.totalTxs || 0),
        transactions: this.transactionsByGroupKey[key] || [],
        createdAt: item.createdAt,
        updatedAt: item.updatedAt,
      }
    })
  }

  get tableRows() {
    const rows = []

    for (const group of this.groupedItems) {
      rows.push({id: group.key, type: 'group', group})

      if (this.expandedGroup === group.key) {
        rows.push({id: group.key + '-hashes', type: 'hashes', group})
      }
    }

    return rows
  }

  mounted() {
    this.applyCollection()
    this.populateResources()
  }

  applyCollection() {
    this.collection.orderBy = 'createdAt'
    this.collection.asc = false
    this.collection.limit = 10
    this.collection.perPage = 10
  }

  async populateResources() {
    this.expandedGroup = null
    this.transactionsByGroupKey = {}
    await $.await.run('softQuery', () => this.collection.queryAsPage())
  }

  async toggleGroup(key: string) {
    if (this.expandedGroup === key) {
      this.expandedGroup = null
      return
    }

    this.expandedGroup = key

    if (this.transactionsByGroupKey[key]) return

    const group = this.groupedItems.find(g => g.key === key)

    if (!group?.address || !group.idOrbitRoundFk) return

    this.loadingHashesKey = key

    try {
      const orbitTransactionGroupSummaryCollection = new OrbitTransactionGroupSummaryCollection()

      orbitTransactionGroupSummaryCollection.address = group.address
      orbitTransactionGroupSummaryCollection.idOrbitRoundFk =
        group.idOrbitRoundFk
      orbitTransactionGroupSummaryCollection.eventname = this.collection.eventname
      orbitTransactionGroupSummaryCollection.hash = this.collection.hash
      orbitTransactionGroupSummaryCollection.networkIdentifier =
        group.networkIdentifier

      const transactions = await orbitTransactionGroupSummaryCollection.listOrbitTransactionGroupedItems()

      this.$set(this.transactionsByGroupKey, key, transactions)
    } finally {
      this.loadingHashesKey = null
    }
  }

  get networkFilterOptions(): OrbitNetworkOption[] {
    return OrbitNetworkHelper.options(this.$translate('view.orbitNetwork.all'))
  }

  get networkFilterSelectValue(): OrbitNetworkOption | null {
    return OrbitNetworkHelper.optionOf(
      this.networkFilterOptions,
      this.networkFilter
    )
  }

  set networkFilterSelectValue(option: OrbitNetworkOption | null) {
    const next = !option || option.$id === '' ? null : option.$id
    if (next === this.networkFilter) return

    this.networkFilter = next
    this.collection.networkIdentifier = next
    this.populateResources()
  }

  async downloadMonthlyReport() {
    const report = await OrbitReport.getMonthlyReport(this.networkFilter)

    OrbitReportPdfHelper.download(report)
  }

  networkLabel(group: TransactionGroup): string {
    return OrbitNetworkHelper.label(group.networkIdentifier)
  }

  networkBadgeClass(group: TransactionGroup): string {
    return OrbitNetworkHelper.badgeClass(group.networkIdentifier)
  }

  handleAddressFilter() {
    if (this.filterTimeout) {
      clearTimeout(this.filterTimeout)
    }

    this.filterTimeout = setTimeout(() => {
      const addressValue = this.filterAddress.trim()

      if (addressValue) {
        this.collection.address = addressValue
      } else {
        this.collection.address = null
      }

      this.populateResources()
    }, 500)
  }

  handleRoundFilter() {
    if (this.filterTimeout) {
      clearTimeout(this.filterTimeout)
    }

    this.filterTimeout = setTimeout(() => {
      const roundValue = this.filterRound.trim()

      if (roundValue) {
        this.collection.round = Number(roundValue)
      } else {
        this.collection.round = null
      }

      this.populateResources()
    }, 500)
  }

  connectN3Address() {
    $.modal.open('connectWalletModal', {
      networkNamespace: NetworkNamespace.n3,
    })
  }

  disconnectN3Address() {
    $.walletAdapter.disconnectN3Wallet()
  }

  truncateAddress(address: string) {
    return address?.trim()
      ? `${address.trim().slice(0, 5)}...${address.trim().slice(-5)}`
      : null
  }

  copyToClipboard(val: string) {
    $.utils.copyToClipboard(val)
    $.toast.info('system.info.copiedToClipboard')
  }

  getDoraTransactionUrl(tx: OrbitTransactionGroupedItem): string {
    const hash = tx.transactionHash

    if (!hash) return ''

    const networkId = tx.networkIdentifier
    const base = EnvHelper.DORA_URL.replace(/\/$/, '')

    return `${base}/transaction/${networkId}/${hash}`
  }
}
